import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamServiceReminderPermissionSet {
  View = 'eam_service_reminder_view',
  Write = 'eam_service_reminder_write',
}

export const EamServiceReminderPermissions = {
  [EamServiceReminderPermissionSet.View]: [
    PermissionType.GET_ANY_EAM_SERVICE_REMINDER,
    PermissionType.RECEIVE_EAM_SERVICE_REMINDER_OVERDUE_ALERT,
    PermissionType.RECEIVE_EAM_SERVICE_REMINDER_DUE_SOON_ALERT,
  ],
  [EamServiceReminderPermissionSet.Write]: [PermissionType.WRITE_ANY_EAM_SERVICE_REMINDER],
}

export const eamServiceReminderPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EamServiceReminder,
  active: EamServiceReminderPermissions,
  unAssignablePermissionSets: [],
}
